import { HttpClient } from '@angular/common/http';
import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { DetalleVenta, Usuario, Venta } from 'src/app/model/index.model';
import { ApiService, WorkshoppingService } from 'src/app/service/index.service';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { environment } from 'src/environments/environment';
registerLocaleData(localeEs, 'es-AR');

@Component({
  selector: 'app-pre-venta',
  templateUrl: './pre-venta.component.html',
  styleUrls: ['./pre-venta.component.scss'],
  providers: [WorkshoppingService, { provide: LOCALE_ID, useValue: 'es-AR' }]
})
export class PreVentaComponent implements OnInit {

  items: DetalleVenta[] = []
  item: Venta
  conf: any
  url: string = environment.configUrl;;

  proccess: boolean = false
  public cotizacion = 1;
  usuario: Usuario;

  constructor(
    private http: HttpClient,
    private wsdl: WorkshoppingService,
    private wsdlApi: ApiService
  ) {
    this.usuario = new Usuario()
    this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))
    this.item = new Venta()
    this.item.id = 1
    this.item.comprador = this.usuario
    this.item.cliente = this.usuario.nombre

    this.item.created_at = '2024-12-16 11:33:00'
    this.items = []

  }

  async ngOnInit() {
    await this.wsdl.registrarCliente();
    await this.wsdl.cargarCarrito();
    await this.actualizarCarrito();

    await this.http.get(this.url).subscribe(res => {
      this.conf = res;
      if (this.conf.dolar) {
        this.getCotizacion();
      } else {
        this.cotizacion = 1
      }
    });

    this.item.total = this.wsdl.calculateTotal()
    this.item.condicion = this.wsdl.condicionVenta
    this.wsdl.actualizarCarritoPorCondicion(this.item.condicion)
  }
  add(item: DetalleVenta) {
    this.wsdl.itemSel(item.mercaderia)
    this.actualizarCarrito()
  }
  dis(item: DetalleVenta) {
    this.wsdl.restarCantidadDelCarrito(item.mercaderia)
    this.actualizarCarrito()
  }
  del(item: DetalleVenta) {
    this.wsdl.eliminarDelCarrito(item.mercaderia)
    this.actualizarCarrito()
  }
  actualizarCarrito() {
    this.items = this.wsdl.detalle
    this.item.total = this.wsdl.calculateTotal()
    this.item.condicion = this.wsdl.condicionVenta
  }
  zfill(number, width) {
    width -= number.toString().length;
    if (width > 0) {
      return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
    }
    return number + "";
  }

  async getCotizacion() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getUsd().then();
      const result = JSON.parse(JSON.stringify(data));
      this.cotizacion = result.venta;
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }

  cambiarCondicionVenta(event: 'contado' | 'debito' | 'tarjeta'): void {
    this.wsdl.actualizarCarritoPorCondicion(event);
    this.actualizarCarrito()
  }

  async generarVenta() {
    try {
      this.actualizarCarrito()
      this.proccess = true
      delete this.item.id
      this.item.cliente = this.usuario.nombre
      let arra = this.items.map(e => "[" + e.cantidad + "] " + e.mercaderia.nombre)
      this.item.descripcion = arra.toString();
      const res = await this.wsdlApi.doVentaGenerate(this.item, this.items, this.cotizacion).then()
      const response = JSON.parse(JSON.stringify(res))
      if (response.code == 200) {
        UturuncoUtils.showToas(response.msg, "success");
        this.item.id = response.data

        if (this.item.condicion === 'tarjeta') {
          const total = this.item.total || 0;
          const descripcion = this.item.descripcion;
          const nombre = this.usuario.nombre;
          const email = this.usuario.correo || 'sinemail@tuapp.com';
          const dni = this.usuario.dni || '00000000';

          try {
            const pago = await this.wsdlApi.generateCheckout(this.item.id, total, descripcion, nombre, email, dni);
            const pagoResponse = JSON.parse(JSON.stringify(pago));
            const checkoutUrl = pagoResponse?.data?.data?.url;

            if (checkoutUrl) {
              // abrir el link de pago
              // 🧹 Limpiar carrito después de cualquier venta exitosa
              this.wsdl.limpiarCarrito();
              this.actualizarCarrito();
              window.location.replace(checkoutUrl);
            } else {
              UturuncoUtils.showToas('No se pudo generar el link de pago.', 'error');
            }
          } catch (err) {
            console.error('Error en Unicobro:', err);
            UturuncoUtils.showToas('Error al generar el pago con tarjeta.', 'error');
          }
        } else {
          // si es contado o débito -> notificar por WhatsApp
          this.wsdl.limpiarCarrito();
          this.actualizarCarrito();
          setTimeout(() => this.notificarPorWhatsApp(this.item), 3000);
        }

      } else {
        UturuncoUtils.showToas(response.msg, "error")
      }
    } catch (error) {
      UturuncoUtils.showToas(error.msg, "error")

    } finally {
      this.proccess = false
    }

  }

  notificarPorWhatsApp(venta: any) {
    // 🧹 Limpiar carrito después de cualquier venta exitosa
    this.wsdl.limpiarCarrito();
    this.actualizarCarrito();
    const numero = this.conf.tel;
    const mensaje =
      `✅ *Nueva venta confirmada*
      👤 Cliente: ${venta.cliente}
      💰 Total: $${venta.total}
      📦 Estado: ${venta.estado}

      🧾 Detalle:
      ${venta.descripcion}`;
    //  🔗 Acceso rápido: ${window.location.origin}/panel/ventas/${venta.id}`;

    const url = `https://api.whatsapp.com/send/?phone=${numero}&text=${encodeURIComponent(mensaje)}`;
    window.location.replace(url);

  }

}
